import { _ as H } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.string.starts-with-a6645e0a.js";
import { c as k } from "./index-8b07dec9.js";
import { useCallback as O } from "react";
import { getAriaProps as S } from "./aria.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.is-array-7a29277f.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.to-string-f55666a8.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as T } from "./getMetrics-953aa4f8.js";
import { a as I } from "./index-5d0f31c6.js";
import "./es.string.link-fd2676c6.js";
import _, { css as C } from "styled-components";
import { jsxs as B, jsx as l } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./es.array.filter-4e9c9996.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./es.object.keys-9d66766f.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-component-foundations";
import "@ucl/shared-icons";
import "./string-html-forced-a746405b.js";
var F = /* @__PURE__ */ _.a.withConfig({
  displayName: "linkstyles__Link",
  componentId: "sc-1qog8mg-0"
})(["&.Link{", "}"], function(n) {
  var i = n.theme.components.link;
  return C(i.Link);
}), N = /* @__PURE__ */ _.span.withConfig({
  displayName: "linkstyles__LinkIcon",
  componentId: "sc-1qog8mg-1"
})(["&.Link__icon{", "}"], function(n) {
  var i = n.theme.components.link;
  return C(i.IconWrapper);
}), G = ["size", "variant", "isDisclosureLink", "disclosureNumber", "isCurrentPage", "disabled", "leadingIcon", "trailingIcon", "to", "target", "rel", "renderAs", "className", "onClick", "onKeyDown", "children"], Oi = function(i) {
  var u = i.size, m = u === void 0 ? "small" : u, g = i.variant, D = g === void 0 ? "default" : g, L = i.isDisclosureLink, p = L === void 0 ? !1 : L, v = i.disclosureNumber, b = i.isCurrentPage, h = b === void 0 ? !1 : b, f = i.disabled, r = f === void 0 ? !1 : f, t = i.leadingIcon, s = i.trailingIcon, o = i.to, c = i.target, P = i.rel, w = i.renderAs, $ = i.className, e = i.onClick, d = i.onKeyDown, x = i.children, A = H(i, G), K = T({
    label: "Link"
  }), j = S(o ? "link" : "button", {
    ariaDisabled: r
  }), y = (o == null ? void 0 : o.startsWith("http")) || (o == null ? void 0 : o.startsWith("#")), z = c || (y ? "_blank" : "_self"), W = {
    as: w,
    to: o
  }, q = {
    href: o,
    rel: P,
    target: z
  }, E = O(function(a) {
    var M = a.code === "Enter" || !o && !c && a.code === "Space";
    M && (e == null || e(a), d == null || d(a));
  }, [e, d, c, o]);
  return /* @__PURE__ */ B(F, Object.assign({}, K, A, {
    as: h ? "span" : "a",
    disabled: r
  }, r && {
    tabIndex: -1
  }, !y && !r && W, !h && !r && q, j, {
    role: o ? "link" : "button",
    onClick: r ? void 0 : e,
    onKeyDown: E,
    "data-disclosure-number": p && v ? v : void 0,
    className: k(["Link", "Link--" + D, "Link--" + m, $, {
      "Link--disabled": r,
      "Link--disclosure": p,
      "disclosure-superscript-link": p
    }]),
    children: [t && /* @__PURE__ */ l(N, {
      className: k(["Link__icon", "Link__icon--left", "Link__icon--" + m]),
      children: typeof t == "string" ? /* @__PURE__ */ l(I, {
        icon: t
      }) : t
    }), x, s && /* @__PURE__ */ l(N, {
      className: k(["Link__icon", "Link__icon--right", "Link__icon--" + m]),
      children: typeof s == "string" ? /* @__PURE__ */ l(I, {
        icon: s
      }) : s
    })]
  }));
};
export {
  Oi as Link
};
